import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import './styles/global.css';

// Lazy load Home page only
const Home = lazy(() => import('./pages/Home'));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    color: '#fff'
  }}>
    <div>Loading...</div>
  </div>
);

function AppContent() {
  return (
    <div className="app closing-page">
      {/* Main Content */}
      <main className="main-content">
        <div className="container">
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </div>
      </main>
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App;
